var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceD6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.875 116.108L239.875 4.219C235 1.406 229.5 0 224 0S213 1.406 208.125 4.219L16.125 116.108C6.125 121.984 0 132.735 0 144.486V367.514C0 379.265 6.125 390.016 16.125 395.892L208.125 507.781C213 510.594 218.5 512 224 512S235 510.594 239.875 507.781L431.875 395.892C441.875 390.016 448 379.265 448 367.514V144.486C448 132.735 441.875 121.984 431.875 116.108ZM224 50.6L376.375 139.361L224 228.247L71.625 139.361L224 50.6ZM48 181.116L200 269.752V447.398L48 358.888V181.116ZM248 447.398V269.752L400 181.116V358.888L248 447.398Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceD6);
export default __webpack_public_path__ + "static/media/dice-d6.674536d87906988e24aa36effca7eae2.svg";
export { ForwardRef as ReactComponent };